import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
import styles from './loadingDropdownItem.module.scss';
export const LoadingDropdownItem = () => (_jsx(FlexBox, Object.assign({ alignItems: "center", justifyContent: "center", className: styles.root }, { children: _jsx(Spinner, { size: 16 }) })));
